import { render, staticRenderFns } from "./CmgRewardsAchievements.vue?vue&type=template&id=80d7d482&scoped=true&lang=pug&"
import script from "./cmg-rewards-achievements.ts?vue&type=script&lang=ts&"
export * from "./cmg-rewards-achievements.ts?vue&type=script&lang=ts&"
import style0 from "./CmgRewardsAchievements.vue?vue&type=style&index=0&id=80d7d482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d7d482",
  null
  
)

export default component.exports